/**************************************************
 * Nombre:       SolicitaMuestrario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import cafe from '../../../../Recursos/cafe_color.svg'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Solicitud from "../../../Dialogos/Dialogo_Solicitud";

const SolicitaMuestrario = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Solicitud, titulo: 'Formulario de solicitud de muestrario'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Button
                    onClick={() => abrir()}
                    color={'secondary'}
                    sx={{py: 2}}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <IconButton>
                                <img src={cafe} width={42} height={'auto'}/>
                            </IconButton>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography>
                                Solicita tu muestrario de café
                            </Typography>
                        </Grid>

                    </Grid>
                </Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 1, md: 1}} sx={{justifyContent: 'flex-start'}}>

            </Grid>

            <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: sCell ? 3 : 0}}>
                <Typography sx={{textAlign: sCell ? 'center' : 'left'}}>
                    Descubre la calidad y el sabor único del café especial. Completa el formulario y nuestro equipo
                    evaluará tu solicitud para enviarte un muestrario seleccionado especialmente para ti, garantizando
                    trazabilidad, frescura y excelencia en cada grano.
                </Typography>
            </Grid>


        </Grid>
    )

}
export default SolicitaMuestrario